import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import * as Icons from '@ant-design/icons-vue'
import router from './router/index'
import { createPinia } from "pinia"
const app = createApp(App)

for (const [key, component] of Object.entries(Icons)) {
  app.component(key, component)
}
const pinia = createPinia()
app.use(Antd)
app.use(router)
app.use(pinia)

// 全局注册懒加载指令
app.directive('lazy-load', {
  mounted(el) {
    // 解决img标签src为空时出现边框，默认给src透明背景即可
    // if(!el.src || el.src === window.location.href){
      // el.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    // }


    // 添加占位样式
    el.classList.add('lazy-image')
 

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target
          const src = img.getAttribute('data-src')

          // 添加加载中状态
          img.classList.add('lazy-loading')
          
          // 创建新的Image对象预加载
          const image = new Image()
          
          image.src = src
          image.onload = () => {
            img.setAttribute('src', src)
            img.classList.remove('lazy-loading')
            img.classList.add('loaded')
          }
          image.onerror = () => {
            img.classList.remove('lazy-loading')
            img.classList.add('lazy-error')
            // 可以设置默认错误图片
            img.setAttribute('src', '/default-error.png')
          }
          
          observer.unobserve(img)
        }
      })
    }, {
      rootMargin: '50px', // 提前50px开始加载
      threshold: 0.1
    })
    
    observer.observe(el)
  }
})

// 挂载应用
app.mount('#app')

